"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.option = void 0;
var option = function (k, o) { return o ? o[k] : undefined; };
exports.option = option;
